import { render } from "./CreateOrUpdateClientRelativesModal.vue?vue&type=template&id=144c2706"
import script from "./CreateOrUpdateClientRelativesModal.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateClientRelativesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__